export const CONCSTT = "CONCSTT";
export const DELIMITER = "---";

export const API_BASE_URL = "https://right2fixapps.com";

export const API_PARAMS = [
  "refine_search",
  "enabled_filters",
  "availability",
  "brand_name",
  "cat_name",
  "subcat_name",
  "part_name",
  "stores",
  "enabled_ranges",
  "ratings_ranges",
  "reviews_ranges",
  "price_ranges",
  "price_type",
  "vehicle_key",
  "search",
] as const;

export const UI_ONLY_PARAMS = ["FilterNav", "expanded"] as const;

export const STORE_NAMES = [
  "Autozone",
  "Oreilly",
  "Amazon",
  "Rockauto",
  "Walmart",
  "Homedepot",
  "Lowes",
  "Advance",
  "Jegs",
  "Finditparts",
  "Truckpro",
  "Napa",
  "Fleetpride",
  "Carparts",
] as const;

export const FILTER_SECTIONS = [
  { key: "availability", label: "Availability" },
  { key: "brands", label: "Brands" },
  { key: "categories", label: "Categories" },
  { key: "refine_search", label: "Refine Search" },
  { key: "ratings", label: "Ratings" },
  { key: "reviews", label: "Reviews" },
  { key: "price", label: "Price" },
  { key: "stores", label: "Stores" },
  { key: "attributes", label: "Attributes" },
  { key: "vehicle", label: "Fitment" },
] as const;

export const DEFAULT_HITS_SIZE = 20;

export const RATINGS_OPTIONS = [
  { label: "4 & Up", value: "4.0-*" },
  { label: "3 & Up", value: "3.0-*" },
  { label: "2 & Up", value: "2.0-*" },
  { label: "1 & Up", value: "1.0-*" },
  { label: "None", value: "mising" },
] as const;

export const REVIEWS_OPTIONS = [
  { label: "1000 & Up", value: "1000.0-*" },
  { label: "500 & Up", value: "500.0-*" },
  { label: "100 & Up", value: "100.0-*" },
  { label: "10 & Up", value: "10.0-*" },
  { label: "1 & Up", value: "1.0-*" },
  { label: "None", value: "mising" },
] as const;

export const PRICE_PRESETS = [
  { label: "Under $25", value: "*-25.0" },
  { label: "Under $50", value: "*-50.0" },
  { label: "Under $100", value: "*-100.0" },
] as const;
